export default __webpack_public_path__ + "static/media/Person-2.9c54fc74.png";